import * as React from 'react';
import { FormikProps } from 'formik';

import { Button, FormCheckbox, FormInput } from 'src/components';
import { IUserCredentials } from 'src/services/user/types';

interface ILoginFormProps extends FormikProps<IUserCredentials> {
  loginError: string;
}

const LoginForm = ({
  errors,
  loginError,
  touched,
  handleSubmit,
  isSubmitting,
}: ILoginFormProps) => (
  <form onSubmit={handleSubmit}>
    <div className="flex items-center my-4">
      <label className="w-32 text-right pr-6" htmlFor="username">
        Username
        {errors.username && touched.username ? (
          <span className="block text-sm text-red">{errors.username}</span>
        ) : null}
      </label>
      <FormInput
        className="flex-1"
        name="username"
        autoFocus={true}
        secondary={true}
      />
    </div>

    <div className="flex items-center my-4">
      <label className="w-32 text-right pr-6" htmlFor="password">
        Password
        {errors.password && touched.password ? (
          <span className="block text-sm text-red">{errors.password}</span>
        ) : null}
      </label>
      <FormInput
        className="flex-1"
        type="password"
        name="password"
        secondary={true}
      />
    </div>
    <FormCheckbox name="remember" className="ml-32 my-6" secondary={true}>
      Remember me
    </FormCheckbox>
    <div className="flex items-center ml-32">
      <Button type="submit" loading={isSubmitting} loadingLabel="Logging in">
        Log in
      </Button>
      {loginError && <span className="flex-1 ml-4 text-red">{loginError}</span>}
    </div>
  </form>
);

export default LoginForm;



// WEBPACK FOOTER //
// ./src/views/Login/components/LoginForm.tsx